export enum AdditionalInfoAction {
  EDIT = "EDIT",
  DELETE = "DELETE",
}

export enum EntityType {
  CASE = "Case",
  SUBCASE = "SubCase",
}
